import { Form } from "antd/es";

export const withForm = <T extends {} = any>(Component: any) => {
  return (props: any) => {
    const [form] = Form.useForm<T>();
    return <Component {...props} form={form} />;
  };
};
